__webpack_require__.p = "/thought-cabinet/";